module.exports = __webpack_public_path__ + "static/media/thumbnail_ally-ups-drape.0d14904e.jpg";